"use client";

import useCashierCurrencyChange from "@casino/server/components/NavBar/LoggedInControls/UserControls/UserBalance/Balance/useBalance/useCashierCurrencyChange";
import useCurrencyChangeListener from "@casino/server/components/NavBar/LoggedInControls/UserControls/UserBalance/Balance/useBalance/useCurrencyChangeListener";
import { useRouter } from "next/navigation";

const useCurrencyRefresh = () => {
  const router = useRouter();
  const handleCurrencyChange = () => router.refresh();

  useCashierCurrencyChange({ onChange: handleCurrencyChange });
  useCurrencyChangeListener({ onChange: handleCurrencyChange });
};

export default useCurrencyRefresh;
